<app-spinner></app-spinner>
<div>
  @if (showErrorMessage) {
    <app-alert [message]="showErrorMessage" [msgtype]="'error'" [messageHeading]="'Error'"></app-alert>
  }
</div>
<div class="inline-text-field-container even-cols flex-row gap-20">
  <div>
    <div class="flex to-block width-full gap-10">
      <div class="inline-text-field-container flex-row gap-20 mb-20 basis-50">
        <div class="container radio-button radio-bg relative">
          <input id="bySystem" name="roleSelectionType" type="radio" value="bySystem"
            [(ngModel)]="roleSelectionType" (click)="onRoleSelectionTypeChange()" tooltip="Choose this option if you are unsure of what role you need">
            <label class="gray-300  click-white" for="bySystem">
              *Select Role By System
            </label>
          </div>
        </div>
        <div class="inline-text-field-container flex-row gap-20 mb-20 basis-50">
          <div class="container radio-button radio-bg relative">
            <input id="byDirectly" name="roleSelectionType" type="radio" value="byDirectly"
              [(ngModel)]="roleSelectionType" (click)="onRoleSelectionTypeChange()" tooltip="Choose this option if you are sure of what role you need">
              <label class="gray-300  click-white" for="byDirectly">
                *Select Role Directly
              </label>
            </div>
          </div>
        </div>
      </div>
      <div></div>
    </div>

      <div class="fade" [hidden]="roleSelectionType !== 'bySystem'">
        <div class="inline-text-field-container even-cols flex-row gap-20">
          <div class="select-container chevron border-bottom border-gray-600 custom-select">
            <select class="ds-select-field rounded-4 hover-gray-300" [(ngModel)]="selectedSystem"
              (change)="getApplicationRolesBySystem($event.target['value'])" [ngClass]="{'disabled': !roleAndOrgSelected()}">
              <option value="" selected="">Select System</option>
              @for (allSystemsKey of dropdowns.allSystemsKeys; track allSystemsKey) {
                <option [value]="allSystemsKey.systemKey">
                  {{allSystemsKey.systemName}}
                </option>
              }
            </select>
            <label class="ds-floating-label">*Select System</label>
          </div>
          <div></div>
        </div>
        <!-- *ngIf="rolesForSelectedSystem?.length > 0" -->
        @if (selectedSystem) {
          <div class="mtb-20 mobile-adjust">
            <div class="card fluid">
              <div class="card__content border-bottom border-gray-500">
                @if (rolesForSelectedSystem?.length > 0) {
                  <div class="width-full">
                    <div>
                      <div class="mtb-10">
                        <b>{{addEmployeeRole() ? 'Role Information': 'Role Select Information'}}</b>
                      </div>
                    </div>
                    <div class="flex gap-30 to-block width-full">
                      <div class="basis-50">
                        <div>
                          <b>{{addEmployeeRole()? 'Role': '*Select Role(s)'}}</b>
                        </div>
                        <div class="mt-10">
                          <ul class="role-checkbox"
                            style="display: flex; flex-direction: column;  overflow: auto;max-height: 500px;">
                            @for (role of rolesForSelectedSystem; track role; let i = $index) {
                              <li class="relative"
                                >
                                <div class="lrg">
                                  <input type="checkbox" [id]="'roleSelect'+i" [name]="'roleSelect'+i"
                                    [value]="role.roleKey" [checked]="isSelected(role)"
                                    (change)="onRoleCheckBoxChage($event, role)">
                                    <label class="ml-10" for="role1">{{role.applicationRoleName}}</label>
                                  </div>
                                  @if (isSelected(role)) {
                                    <div class="inline-text-field-container fade">
                                      <div class="mb-5"><span style="color: red;font-size: 24px;">*</span>Reason for Requesting the role.</div>
                                      <div class="text-area-container">
                                        <label for="address2"
                                        class="ds-floating-label text-area">Please add reason to Add Role</label>
                                        <textarea class="textarea" name="reason" rows="3" required [(ngModel)]="role.reason"></textarea>
                                      </div>
                                    </div>
                                    <div
                                      class="inline-text-field-container even-cols flex-row gap-20 mt-10">
                                      <div class="ds-text-field gray">
                                        <input class="ds-text-field__input" id="effectiveDate" type="date"
                                          name="effectiveDate" autocomplete="off" required="" [(ngModel)]="role.effectiveDate" [min]="today">
                                          <label for="address" class="ds-floating-label ">*Effective
                                          Date</label>
                                          <div class="field-line-ripple blue"></div>
                                          <span class="help display-none"></span>
                                          <span class="error display-none"></span>
                                        </div>
                                        <div></div>
                                      </div>
                                    }
                                  </li>
                                }
                              </ul>
                            </div>
                          </div>
                          <div class="basis-50">
                            <div>
                              <b>Permissions Granted</b>
                            </div>
                            <div style="overflow: auto;max-height: 530px;">
                              @for (role of selectedRoles; track role) {
                                <div class="mtb-10 responsibility">
                                  <div>
                                    <b>{{role.applicationRoleName}}</b>
                                  </div>
                                  <ul>
                                    <li *ngFor="let roleResponsibility of role.roleResponsibilities">
                                      {{roleResponsibility}}
                                    </li>
                                  </ul>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="container flex mobile border-top border-gray-500 pt-10">
                            <span class="basis-50">
                              <span class="flex justify-start">
                                @if (selectedRoles?.length > 0) {
                                  <button class="rounded-4 hover-blue-800 black mobile" (click)="addRolesToCart()"
                                    >
                                    <div class="btn-txt font-white bold">*Add Role(s)
                                    to Cart</div>
                                  </button>
                                }
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                    @if (!rolesForSelectedSystem?.length) {
                      <div class="width-full">
                        <div class="flex justify-center">
                          <div class="mtb-20">
                            <b>No roles found for the selected system.</b>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
        </div>


          <div [hidden]="roleSelectionType !== 'byDirectly'">
            <div class="fade">
              <div class="inline-text-field-container even-cols flex-row gap-20">
                <ng-select class="custom" (change)="getApplicationRolesByRoleKey($event)" [(ngModel)]="selectRoleNgModel" style="width: 50%;" [ngClass]="{'disabled': !roleAndOrgSelected()}"
                  placeholder="*Select Role" [items]="dropdowns.userRoles" bindLabel="applicationRoleName" bindValue="roleKey">
                  <ng-template ng-multi-label-tmp let-items="items">
                    <div class="ng-value">
                      <span class="ng-value-label">*Select Role</span>
                    </div>
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <span class="ng-value-label">{{item.applicationRoleName}}</span>
                  </ng-template>
                </ng-select>
                <div></div>
              </div>
              <div class="mtb-20 mobile-adjust">
                @if (selectedRole) {
                <div class="card fluid">
                  <div class="card__content border-bottom border-gray-600">
                      <div class="width-full">
                        <div>
                          <div class="mtb-10">
                            <b>Role Information</b>
                          </div>
                        </div>
                        @if (systemsForSelectedRole?.length) {
                        <div
                          class="flex gap-30 to-block width-full border-bottom border-gray-600 mb-20 pb-10 max-scroll">
                          <div class="basis-50">
                            <div>
                              <b>System</b>
                            </div>
                            <div class="mt-10 basis-50">
                              <ul class="system">
                                @for (system of systemsForSelectedRole; track system) {
                                  <li>
                                    {{system.systemName}}
                                  </li>
                                }
                              </ul>
                            </div>
                          </div>
                          <div class="basis-50">
                            <div>
                              <b>Responsibilities</b>
                            </div>
                            @for (system of systemsForSelectedRole; track system) {
                              <div class="mt-10">
                                <div>
                                  <b>{{system.systemName}}</b>
                                </div>
                                <ul class="responsibility">
                                  <ng-container *ngFor="let systemResponsibility of system.roleResponsibility?.split('.')">
                                    <li *ngIf="systemResponsibility">
                                      {{systemResponsibility}}.
                                    </li>
                                  </ng-container>
                                </ul>
                              </div>
                            }
                          </div>
                        </div>
                      }
                        <div class="mt-20">
                          <div class="inline-text-field-container">
                            <div class="mb-5"><span style="color: red;font-size: 24px;">*</span>Reason for requesting the role.</div>
                            <div class="text-area-container">
                              <label for="address2" class="ds-floating-label text-area">Reason</label>
                              <textarea class="textarea" name="reason" rows="3" required [(ngModel)]="selectRoleDirectlyDtls.reason"></textarea>
                            </div>
                          </div>
                          <div class="inline-text-field-container even-cols flex-row gap-20 mt-20">
                            <div class="ds-text-field gray">
                              <input class="ds-text-field__input" id="address" type="date" name="effectiveDate" [min]="today" [(ngModel)]="selectRoleDirectlyDtls.effectiveDate"
                                autocomplete="off" value="" required="">
                                <label for="address" class="ds-floating-label">*Effective Date</label>
                                <div class="field-line-ripple blue"></div>
                                <span class="help display-none"></span>
                                <span class="error display-none"></span>
                              </div>
                              <div></div>
                              <div></div>
                            </div>
                            <div class="container flex mobile border-top border-gray-600 mt-20 pt-10">
                              <span class="basis-50">
                                <span class="flex justify-start">
                                  <button class="rounded-4 hover-blue-800 black mobile"
                                    (click)="addRolesToCart()">
                                    <div class="btn-txt font-white bold">*Add Role(s) to Cart</div>
                                  </button>
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          <!--End This will show Role directly  -->
          <!-- This will show Role  by system  -->

          <app-role-request-cart [rolesOnCart]="rolesOnCart" (removeRole)="removeRole($event)"></app-role-request-cart>